import { TranslationContainer } from "../localization/LocalizationProvider";

export function useTranslation() {
    return TranslationContainer.useContainer();
}

